import { createContext, Dispatch, SetStateAction, useContext } from 'react';

interface IEngagePanelContext {
	openCardId: string | null;
	setOpenCardId: Dispatch<SetStateAction<string | null>>;
}

// lets the above-the-fold panel hide what's covered by an expanded engage card
export const EngagePanelContext = createContext<IEngagePanelContext | null>(null);

export const useEngagePanel = () => {
	return useContext(EngagePanelContext);
};
